import { getRowColFromIndex } from "./drawing.js";
import { isSolved, drawLastTitle } from "./solved.js";
import { findBlankIndex } from "./solved.js";
import { updateScore } from "./api/updateScore";
import { bestCurrentUserScore } from "./bestCurrentUserScore.js";
import "../CSS/moving.css";
import dotenv from "dotenv";

dotenv.config();

export function move(
  event,
  shuffledIds,
  titleIds,
  titleImgs,
  ctx,
  board,
  canvas,
  addClick,
  removeClick,
  clicker
) {
  event.preventDefault();
  let coords = getMouseCoords(event.clientX, event.clientY, board, canvas);
  let titleX = coords.x;
  let titleY = coords.y;
  let blankCoords = getRowColFromIndex(
    findBlankIndex(shuffledIds),
    board.rowCols
  );
  let blankX = blankCoords.x;
  let blankY = blankCoords.y;
  if (!hasBlankNeighbour(titleX, titleY, blankX, blankY)) return;
  addClick();
  const swapDataImage = ctx.getImageData(
    titleX * board.titleWidth,
    titleY * board.titleHeight,
    board.titleWidth,
    board.titleHeight
  );
  ctx.fillRect(
    titleX * board.titleWidth,
    titleY * board.titleHeight,
    board.titleWidth,
    board.titleHeight
  );
  ctx.putImageData(
    swapDataImage,
    blankX * board.titleWidth,
    blankY * board.titleHeight
  );
  const imgIdx = getIndexFromCoords(titleX, titleY, board);
  const blnIdx = getIndexFromCoords(blankX, blankY, board);

  swapIndex(imgIdx, blnIdx, shuffledIds, canvas);
  if (isSolved(shuffledIds, titleIds)) {
    Number(clicker++);
    removeClick();
    drawLastTitle(titleIds, titleImgs, ctx, board, shuffledIds);

    document.querySelector("#backToMenu").remove();
    document.querySelector("#shuffle-image").remove();
    document.querySelector(".game-header").remove();
    document.querySelector("#game").style.marginTop = "25.5px";

    const footer = document.querySelector(".game-footer");
    const buttonRes = document.createElement("button");
    buttonRes.id = "results";
    buttonRes.classList = "button";
    buttonRes.innerText = "Rezultatas";
    footer.appendChild(buttonRes);

    buttonRes.addEventListener("click", () => {
      buttonRes.remove();
      const diff = document.getElementById("difficulty-selected").dataset.value;
      const user = window.localStorage.getItem(
        `realm-web:app(${process.env.REALM_WEB_ID}):userIds`
      );
      const solvedCanvasResults = document.querySelector(
        ".solved-canvas-results"
      );

      bestCurrentUserScore(user, diff);

      document.querySelector(
        ".result-score"
      ).innerText = `Jūsų dabartinis rezultatas: ${clicker}`;
      document.getElementById("solved").style.display = "flex";

      if (user) {
        const score = JSON.parse(window.localStorage.getItem("difficulty"));
        if (score[0][diff] === undefined || score[0][diff].score > clicker) {
          const buttonShare = document.createElement("button");
          buttonShare.innerText = "Išsaugoti";
          buttonShare.id = "share";
          buttonShare.classList = "button";
          solvedCanvasResults.appendChild(buttonShare);

          buttonShare.addEventListener("click", async (e) => {
            e.preventDefault();
            buttonShare.disabled = true;
            if (score[0][diff] === undefined) {
              const result = await updateScore(clicker);
              if (!result.success) {
                setError(result.data);
                return;
              }
              score[0][diff] = { score: clicker };
              window.localStorage.setItem("difficulty", JSON.stringify(score));
              setSuccess("Rezultatas sėkmingai nustumtas į lentelę.");
            } else if (score[0][diff].score > clicker) {
              const result = await updateScore(clicker);
              if (!result.success) {
                setError(result.data);
                return;
              }
              score[0][diff].score = clicker;
              window.localStorage.setItem("difficulty", JSON.stringify(score));
              setSuccess("Rezultatas sėkmingai nustumtas į lentelę.");
              solvedCanvasResults.removeChild(buttonShare);
            }
          });
          function setSuccess(successMessage) {
            const success = document.createElement("div");
            success.classList.add("success-message");
            success.textContent = successMessage;
            document
              .querySelector(".solved-canvas-results")
              .appendChild(success);
          }
          function setError(message) {
            const error = document.createElement("div");
            error.classList.add("error-message");
            error.textContent = message;
            document.querySelector(".solved-canvas-results").appendChild(error);
          }
        }
      }
      const buttonBackToMenu = document.createElement("button");
      buttonBackToMenu.innerText = "Grįžti į meniu";
      buttonBackToMenu.id = "backToMenu";

      solvedCanvasResults.appendChild(buttonBackToMenu);

      buttonBackToMenu.addEventListener("click", () => {
        document.querySelector("#game").remove();
        document.querySelector("#menu").style.display = "flex";
      });
    });
  }
}
function getMouseCoords(x, y, board, canvas) {
  let offset = canvas.getBoundingClientRect();
  let left = Math.floor(offset.left);
  let top = Math.floor(offset.top);
  let row = Math.floor((x - left) / board.titleWidth);
  let col = Math.floor((y - top) / board.titleHeight);
  return { x: row, y: col };
}

function hasBlankNeighbour(titleX, titleY, blankX, blankY) {
  if (titleX != blankX && titleY != blankY) return false;
  if (Math.abs(titleX - blankX) == 1 || Math.abs(titleY - blankY) == 1)
    return true;
  return false;
}
function getIndexFromCoords(x, y, board) {
  return x + y * board.rowCols;
}
function swapIndex(imgIdx, blankIdx, shuffledIds) {
  shuffledIds[blankIdx] = shuffledIds[imgIdx];
  shuffledIds[imgIdx] = -1;
}
